import React from 'react'
import { Box } from '@mui/material'
import { EmtTypography, EmtButton, EmtModal, useMobile } from 'emt-components-v2'

interface SecurityModalProps {
  open: boolean
  onClose: () => void
  pro: boolean
  pendingMessage: string
  onModifyMessage: (message: string) => void
}

const SecurityModal: React.FC<SecurityModalProps> = ({ open, onClose, pro, pendingMessage, onModifyMessage }) => {
  const [isMobile] = useMobile()

  const handleModifyMessage = () => {
    onClose()
    onModifyMessage(pendingMessage)
  }

  return (
    <EmtModal
      open={open}
      onClose={onClose}
      sx={{
        '& .inner-box': { backgroundColor: '#F9F9F9', width: '600px', maxWidth: '90vw' },
        '& .children-box': { maxHeight: '80vh', padding: isMobile ? '20px' : '32px' },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {pro ? (
          <>
            <EmtTypography variant="h4" fontWeight={800}>
              Rappel important
            </EmtTypography>
            <EmtTypography variant="body1">
              Ce message semble faire référence à des communications ou un paiement en dehors de notre plateforme.
            </EmtTypography>
            <EmtTypography variant="body1">
              Conformément à nos CGU,{' '}
              <strong>toutes les communications avant paiement doivent passer par notre messagerie.</strong> Echanger
              vos coordonnées avant le paiement de la réservation sur la plateforme peut entraîner une exclusion
              définitive.
            </EmtTypography>
            <EmtTypography variant="body1">
              En effectuant la réservation sur la plateforme, vous restez protégé : assistance vétérinaire 24h/24,
              paiement garanti, assistance en cas de litige, etc.
            </EmtTypography>
          </>
        ) : (
          <>
            <EmtTypography variant="h4" fontWeight={800}>
              Ne prenez pas de risques
            </EmtTypography>
            <EmtTypography variant="body1">
              Ce message semble faire référence à des communications ou un paiement en dehors de notre plateforme.
            </EmtTypography>
            <EmtTypography variant="body1">
              <strong>Réserver hors de notre plateforme vous expose vous et vos animaux à des risques :</strong> fraude,
              pas de remboursement et d&apos;assistance si le pet sitter annule en dernière minute, pas de règles en cas
              de litige, pas d&apos;assistance vétérinaire 24h/24, hésitation du pet sitter à se rendre chez le
              vétérinaire car pas de remboursement par notre garantie.
            </EmtTypography>
            <EmtTypography variant="body1">
              Pour votre sécurité, communiquez et payez sur Emprunte Mon Toutou.
            </EmtTypography>
          </>
        )}

        <Box sx={{ display: 'flex', gap: '16px', flexDirection: isMobile ? 'column' : 'row' }}>
          <EmtButton fullWidth color="purple" onClick={handleModifyMessage}>
            Modifier mon message
          </EmtButton>
        </Box>
      </Box>
    </EmtModal>
  )
}

export default SecurityModal
